<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="breadcrumb"></ch-breadcrumb>
  <form (ngSubmit)="save(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <div class="card mb-4">
            <div class="card-header">Form</div>
            <div class="card-body">
              <div class="form-group">
                <label for="rewards-edit-target">Target</label>
                <select id="rewards-edit-target" class="form-control" [(ngModel)]="referralRewardData.target"
                  name="rewards-edit-target" #target="ngModel" required disabled>
                  <option *ngFor="let option of referralRewardTargetOptions" value="{{ option.value }}">
                    {{ option.label }}
                  </option>
                </select>
                <small class="text-danger" *ngIf="(target.touched || target.dirty) && !target.valid">
                  Target is invalid.
                </small>
              </div>
              <div class="form-group">
                <div>
                  <label>
                    <input type="radio" name="couponOption" [(ngModel)]="existingCoupon" [value]="true" />
                    Existing Coupon
                  </label>
                </div>
                <div>
                  <label>
                    <input type="radio" name="couponOption" [(ngModel)]="existingCoupon" [value]="false" />
                    New Coupon
                  </label>
                </div>
              </div>
              <ng-container *ngIf="existingCoupon; else newCoupon">
                <div class="form-group">
                  <label for="rewards-edit-coupon">Coupon</label>
                  <select id="rewards-edit-coupon" class="form-control" [(ngModel)]="referralRewardData.couponId"
                    name="rewards-edit-coupon" #coupon="ngModel" required>
                    <option *ngFor="let option of coupons" value="{{ option.id }}">
                      {{ option.name }}
                    </option>
                  </select>
                  <small class="text-danger" *ngIf="(coupon.touched || coupon.dirty) && !coupon.valid">
                    Coupon is invalid.
                  </small>
                </div>
              </ng-container>
              <ng-template #newCoupon>
                <div class="form-group">
                  <label>New coupon:</label>
                  <div>
                    <label>
                      <input type="radio" name="couponImportOption" [(ngModel)]="importCoupon" [value]="true" />
                      Import Coupon
                    </label>
                  </div>
                  <div>
                    <label>
                      <input type="radio" name="couponImportOption" [(ngModel)]="importCoupon" [value]="false" />
                      Create Coupon
                    </label>
                  </div>
                </div>
                <div class="form-group">
                  <label style="width: 100%">
                    Name
                    <input type="text" name="couponName" [(ngModel)]="newCouponData.name" required
                      class="form-control" />
                  </label>
                </div>
                <ng-container *ngIf="importCoupon; else createCoupon">
                  <div class="form-group">
                    <label style="width: 100%">
                      Stripe ID
                      <input type="text" name="couponStripeId" [(ngModel)]="newCouponData.stripeId" required
                        class="form-control" />
                    </label>
                  </div>
                </ng-container>
                <ng-template #createCoupon>
                  <div class="form-group">
                    <label style="width: 100%">
                      Duration (months)
                      <input type="number" name="couponDuration" [(ngModel)]="newCouponData.durationInMonths" required
                        class="form-control" max="12" />
                    </label>
                    <small class="text-danger" *ngIf="newCouponData.durationInMonths > 12">
                      Referral reward coupons can only have a duration of up to
                      12 months.
                    </small>
                  </div>
                  <div class="form-group">
                    <label style="width: 100%">
                      Discount (percent)
                      <input type="number" name="couponDiscount" [(ngModel)]="newCouponData.percentOff" required min="0"
                        max="100" class="form-control" />
                    </label>
                  </div>
                </ng-template>
              </ng-template>
              <ng-container *ngIf="referralRewardData.target === 'REFEREE'">
                <div class="form-group">
                  <label for="rewards-edit-plan">Applicable to Plan</label>
                  <select id="rewards-edit-plan" class="form-control" [(ngModel)]="referralRewardData.planId"
                    name="rewards-edit-plan" #plan="ngModel">
                    <option value="">Any</option>
                    <optgroup label="RAF Default Plans">
                      <ng-container *ngFor="let option of rafDefaultPlans">
                        <option [value]="option.id">
                          {{ option.name }}
                        </option>
                      </ng-container>
                    </optgroup>
                    <optgroup label="Other Plans">
                      <ng-container *ngFor="let option of nonRafDefaultPlans">
                        <option [value]="option.id">
                          {{ option.name }}
                        </option>
                      </ng-container>
                    </optgroup>
                  </select>
                  <small class="text-danger" *ngIf="(plan.touched || plan.dirty) && !plan.valid">
                    Plan is invalid.
                  </small>
                </div>
              </ng-container>
              <ng-container *ngIf="referralRewardData.target === 'REFERRER'">
                <hr />
                <div class="form-group">
                  <label for=" rewards-edit-type">Type
                    <small *ngIf="!referralRewardId" class="text-muted">
                      (this field won't be editable later)
                    </small>
                  </label>
                  <select id="rewards-edit-type" class="form-control" [(ngModel)]="referralRewardData.type"
                    name="rewards-edit-type" #type="ngModel" required [disabled]="referralRewardId">
                    <option *ngFor="let option of referralRewardTypeOptions" value="{{ option.value }}">
                      {{ option.label }}
                    </option>
                  </select>
                  <small class="text-danger" *ngIf="(type.touched || type.dirty) && !type.valid">
                    Type is invalid.
                  </small>
                </div>
                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input id="rewards-edit-auto-redeem" #referralRewardAutoRedeem type="checkbox" name="auto-redeem"
                      [(ngModel)]="referralRewardData.autoRedeem" class="custom-control-input" />
                    <label class="custom-control-label" for="auto-redeem">Auto Redeem?</label>
                  </div>
                </div>
                <div class="form-group">
                  <label for="rewards-edit-referrals-count">Referrals Count</label>
                  <input type="number" name="rewards-edit-referrals-count" class="form-control"
                    id="rewards-edit-referrals-count-input" [(ngModel)]="referralRewardData.referralsCount"
                    #referralRewardReferralsCount="ngModel" min="1" required [readonly]="formLocked" />
                  <small class="text-danger" *ngIf="
                      (referralRewardReferralsCount.touched ||
                        referralRewardReferralsCount.dirty) &&
                      (!referralRewardReferralsCount.valid ||
                        !referralRewardData.referralsCount ||
                        referralRewardData.referralCount < 1)
                    ">
                    Referrals count should be positive.
                  </small>
                </div>
                <div class="form-group">
                  <label for="rewards-edit-max-redemptions-per-member">Max Redemptions Per Member</label>
                  <input type="number" name="rewards-edit-max-redemptions-per-member" class="form-control"
                    id="rewards-edit-max-redemptions-per-member-input"
                    [(ngModel)]="referralRewardData.maxRedemptionsPerMember"
                    #referralRewardMaxRedemptionsPerMember="ngModel" min="1" [readonly]="formLocked" />
                  <small class="text-danger" *ngIf="
                      (referralRewardMaxRedemptionsPerMember.touched ||
                        referralRewardMaxRedemptionsPerMember.dirty) &&
                      (!referralRewardMaxRedemptionsPerMember.valid ||
                        (referralRewardData.maxRedemptionsPerMember &&
                          referralRewardData.maxRedemptionsPerMember < 1))
                    ">
                    Max redemptions per member should be non-negative or empty.
                  </small>
                </div>
              </ng-container>
              <div style="margin-top: 40px">
                <span class="btn-left" *ngIf="referralRewardId">
                  <button id="referralProgramsEditCancel" type="button" class="btn btn-danger" (click)="delete()"
                    [disabled]="loading">
                    Delete
                  </button>
                </span>
                <span class="btn-right">
                  <button id="jobCategoriesEditCancel" type="button" class="btn btn-secondary" (click)="cancel()"
                    [disabled]="loading">
                    Cancel
                  </button>
                  <button id="jobCategoriesEditSave" type="submit" class="btn btn-primary" [disabled]="loading">
                    Save
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/referrals/rewards/rewards-edit.component.html